class UserService {
  private currentUser: any = null;
  private siteInfo: any = null;
  private user_nm: any = null;
  private device: any = null;
  private modes: any[] = [];
  private userListeners: Array<(user: any) => void> = [];
  private siteListeners: Array<(sites: any[]) => void> = [];

  setUser(user: any): void {
    this.currentUser = user;
    for (const cb of this.userListeners) cb(user);
  }

  getUser(callback: (user: any) => void): () => void {
    this.userListeners.push(callback);
    callback(this.currentUser);
    return () => {
      this.userListeners = this.userListeners.filter(cb => cb !== callback);
    };
  }

  getCurrentUser(): any {
    return this.currentUser;
  }

  setSiteInfo(item: any): void {
    this.siteInfo = item;
    for (const cb of this.siteListeners) cb(item);
  }

  getSiteInfo(): any {
    return this.siteInfo;
  }

  setModes(modes: any[]): void {
    this.modes = modes;
  }

  getModes(): any[] {
    return this.modes;
  }

  setDevice(item: any): void {
    this.device = item;
  }

  getDevice(): any {
    return this.device;
  }

  setUserName(nm: any): void {
    this.user_nm = nm;
  }

  getUserName(): any {
    return this.user_nm;
  }

  subscribe(callback: (sites: any[]) => void): void {
    this.siteListeners.push(callback);
  }

  unsubscribe(callback: (sites: any[]) => void): void {
    this.siteListeners = this.siteListeners.filter(cb => cb !== callback);
  }
}

export const userService = new UserService();
